import { GrupoAlvoVacinacaoEnum } from 'graphql/types.generated'
import moment from 'moment'

import { StatusDoseEnum } from './model'

export function getStatusDoseVacinacao(
  dataNascimento: LocalDate,
  dataAtendimento: Instant,
  diasInicioFaixaEtaria: number,
  diasFimFaixaEtaria: number
): StatusDoseEnum {
  const now = moment(dataAtendimento)
  const birthMoment = moment(dataNascimento)

  const duration = moment.duration(now.diff(birthMoment))
  const idadeAtualEmDias = periodToDays(duration.years(), duration.months(), duration.days())

  if (idadeAtualEmDias < diasInicioFaixaEtaria) {
    return StatusDoseEnum.FUTURA
  } else if (idadeAtualEmDias > diasFimFaixaEtaria) {
    return StatusDoseEnum.ATRASADA
  }
  return StatusDoseEnum.DISPONIVEL
}

export function getGrupoAlvoVacinacao(dataNascimento: LocalDate, dataAtendimento: Instant): GrupoAlvoVacinacaoEnum {
  const now = moment(dataAtendimento)
  const birthMoment = moment(dataNascimento)

  const idadeEmAnos = now.diff(birthMoment, 'years')
  if (idadeEmAnos >= 60) {
    return GrupoAlvoVacinacaoEnum.IDOSO
  } else if (idadeEmAnos >= 20) {
    return GrupoAlvoVacinacaoEnum.ADULTO
  } else if (idadeEmAnos >= 10) {
    return GrupoAlvoVacinacaoEnum.ADOLESCENTE
  } else {
    return GrupoAlvoVacinacaoEnum.CRIANCAS
  }
}

export function getDescricaoTituloCalendario(grupoAlvo: GrupoAlvoVacinacaoEnum): string {
  switch (grupoAlvo) {
    case GrupoAlvoVacinacaoEnum.CRIANCAS:
      return 'da criança'
    case GrupoAlvoVacinacaoEnum.ADOLESCENTE:
      return 'do adolescente'
    case GrupoAlvoVacinacaoEnum.ADULTO:
      return 'do adulto'
    case GrupoAlvoVacinacaoEnum.IDOSO:
      return 'do idoso'
  }
}

function periodToDays(years: number, months: number, days: number) {
  const daysInMonth = 31
  return years * (12 * daysInMonth) + months * daysInMonth + days
}
